import { Settings } from '@features/settings/components/Settings'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/settings')({
    component: Settings,
})